import React from 'react'
import PropTypes from 'prop-types'

import { constants, strings } from 'helpers'
import { EventImageWithAspectRatio, HostProfileImage } from 'components'
import EventCardSmallContainer from './EventCardSmallContainer'
import EventTime from './EventTime'
import EventLock from './EventLock'
import EventTags from './EventTags'

const {
  EVENT_CONSTANTS: { TEXT_TRIM_LENGTH },
} = constants

const Small = ({
  id,
  title,
  description,
  image,
  location,
  tagsByType,
  startTime,
  status,
  host,
  isAuthenticated,
  footer,
  hideTags,
  className,
}) => (
  <EventCardSmallContainer className={className} data-eventid={id}>
    <div className="h-full flex flex-col justify-between pb-4">
      <div>
        <div className="flex px-5 py-4">
          {isAuthenticated ? (
            <HostProfileImage src={host.logo} alt={host.name} className="rounded-full w-10 h-10" />
          ) : (
            <EventLock />
          )}
          <EventTime
            startTime={startTime}
            status={status}
            classNames={{ wrapper: 'ml-4', countdown: 'font-bold w-28', date: 'text-xs' }}
          />
        </div>
        <EventImageWithAspectRatio src={image} atl="" />
        <div className="px-5 py-4 pb-0">
          {!hideTags && <EventTags location={location} tagsByType={tagsByType} />}
          <h2 className="text-white text-2xl font-ownersWide">
            {strings.trim(title, TEXT_TRIM_LENGTH.TITLE)}
          </h2>
          <p
            className="mt-3 text-sm text-gray-400 overflow-hidden overflow-ellipsis font-tomatoGrotesk-reg"
            dangerouslySetInnerHTML={{
              __html: strings.trim(description, TEXT_TRIM_LENGTH.DESCRIPTION),
            }}
          />
        </div>
      </div>
      {!!footer && <div className="px-4 pb-2">{footer}</div>}
    </div>
  </EventCardSmallContainer>
)

Small.propTypes = {
  shouldRenderContent: PropTypes.bool,
  footer: PropTypes.element,
  className: PropTypes.string,
  status: PropTypes.string,
  isAuthenticated: PropTypes.bool,
}

Small.defaultProps = {
  shouldRenderContent: false,
  className: '',
}

export default Small
